import { useInfiniteQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { api } from '@/modules/common/api/index.ts';
import { REGISTER_ID_SEARCH_PARAM_KEY } from '@/modules/common/constants/search-params.ts';
import {
  GetInvestorCertificateListResponse,
  GetListByInvestorV1SrCertificatesInvestorGetParams,
} from 'api';

export const INVESTOR_CERTIFICATES_LIST_QUERY_KEY = 'vestra-sr/investor-certificates-list';

export const useInvestorGetCertificatesQuery = (
  payload: GetListByInvestorV1SrCertificatesInvestorGetParams,
) => {
  const { page } = payload;
  const [params] = useSearchParams();

  return useInfiniteQuery<GetInvestorCertificateListResponse>({
    queryKey: [
      INVESTOR_CERTIFICATES_LIST_QUERY_KEY,
      JSON.stringify(payload),
      params.get(REGISTER_ID_SEARCH_PARAM_KEY),
    ],
    staleTime: 1000 * 60 * 60, // 1 hours
    refetchInterval: 1000 * 60 * 5, //5min
    queryFn: async ({ pageParam = 0 }) => {
      const response = await api.v1.getListByInvestorV1SrCertificatesInvestorGet({
        ...payload,
        page: pageParam || page,
      });
      return response.data;
    },
    keepPreviousData: true,
    retry: 2,
    getNextPageParam: ({ total, page, page_size }) => {
      const totalPage = Math.ceil(total / page_size);
      const hasMore = totalPage > page;
      if (hasMore) {
        return page + 1;
      }
    },
  });
};
